import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Page } from '../shared';

import { sprintGoalsAreDirty } from '../../util';

import { Link } from 'react-router-dom';

import { getFourboxTalentCategories } from '../../util';

import {
  fetchCurrentSprintForEmployee,
  saveCurrentSprintForEmployee,
} from '../../actions/sprint';

import { getIcon } from '../../util/icons';

class PlanPage extends Component {

  state = {
    cachedSprint: null,
    updatedSprint: null,
  }

  renderPageTitle(){

    return (
      <div className="page-title no-subheader">
        <h1>{this.props.isViewingUser ? (this.props.viewingUser || {}).firstName : 'Your'} Action Plan</h1>
      </div>
    )
  }

  componentWillMount(){

    const { match: { params } } = this.props;

    let employeeId = params.employeeId;

    //if no employeeId...user accessing sprint
    //TODO figure out a better way of managing this
    if(employeeId){
      this.setState({
        employeeId,
        isOwnSprint: false,
      })
    }
    else{
      employeeId = this.props.user.uid;

      this.setState({
        employeeId,
        isOwnSprint: true,
      });
    }

    this.props.fetchCurrentSprintForEmployee(employeeId);
  }

  componentWillReceiveProps(nextProps){

    console.log('plan received props: ', nextProps);

    if(!nextProps.savingSprint && nextProps.sprintData){
      this.setState({
        cachedSprint: nextProps.sprintData,
        updatedSprint: nextProps.sprintData,
      });
    }
  }

  goalsForCategory(category){

    const { goals } = this.state.updatedSprint || {};

    return _.filter(goals, goal => {
      return goal.category === category;
    });
  }

  renderGoal(goal){

    const { isViewingUser, viewingUser } = this.props;
    const { smartGoal, actionPlan } = (goal.goalMeta || {});

    // console.log('rendering goal: ', goal);

    const goalPlaceholder = `How will ${isViewingUser ? (viewingUser || {}).firstName : 'you'} use this ${goal.category} to sell more?`;
    const planPlaceholder = `How will ${isViewingUser ? (viewingUser || {}).firstName : 'you'} improve this ${goal.category}?`;

    return(
      <div key={goal.id} className="goal">
        <div className="goal-name">{goal.name}</div>
        <div className="goal-definition">{goal.definition || `Example definition for ${goal.name}`}</div>

        <label>Goal</label>
        <textarea
          value={smartGoal}
          onChange={e => { this.updateGoalSmartGoal(goal, e.target.value) }}
          className="goal-smart-goal"
          placeholder={goalPlaceholder}
        ></textarea>

        <label>Action plan</label>
          <textarea
            value={actionPlan}
            onChange={e => { this.updateGoalActionPlan(goal, e.target.value) }}
            className="goal-action-plan"
            placeholder={planPlaceholder}
          ></textarea>
      </div>
    )
  }

  updateGoalInSprint(goal){

    //copy goals since we will be manipulating array
    let goals = [ ...this.state.updatedSprint.goals];

    let matchingGoalIndex = _.findIndex(goals, item => {
      return item.id === goal.id;
    });

    if(matchingGoalIndex !== -1){
      //https://stackoverflow.com/questions/27641731/is-there-a-function-in-lodash-to-replace-matched-item
      goals.splice(matchingGoalIndex, 1, {
        ...goals[matchingGoalIndex],
        ...goal,
      });
    }
    else{
      goals.push(goal);
    }

    this.setState({
      updatedSprint: {
        ...this.state.updatedSprint,
        goals
      }
    });
  }

  updateGoalMeta(goal, newMeta){
    const updatedGoal = {
      ...goal,
      goalMeta: {
        ...goal.goalMeta,
        ...newMeta
      }
    }

    this.updateGoalInSprint(updatedGoal);
  }

  updateGoalSmartGoal(goal, newValue){
    this.updateGoalMeta(goal, {
      smartGoal: newValue
    });
  }
  updateGoalActionPlan(goal, newValue){
    this.updateGoalMeta(goal, {
      actionPlan: newValue
    });
  }

  renderGoals(){
    const { goals } = this.state.updatedSprint || {};

    if(!goals){
      return null;
    }

    return (
      <div className="my-goals">
        {_.map(getFourboxTalentCategories(), talentCategory => {
          return (
            <div key={talentCategory.key} className="goal-category">
              <div className="goals-section-header">{talentCategory.name}</div>
              {_.map(this.goalsForCategory(talentCategory.key), this.renderGoal.bind(this))}
            </div>
          );
        })}
      </div>
    )
  }

  saveSprint(){
    console.log('saving sprint: ', this.state.updatedSprint);
    this.props.saveCurrentSprintForEmployee(this.state.updatedSprint._id, this.state.updatedSprint);
  }

  sprintIsDirty(){
    if(!this.state.cachedSprint || !this.state.updatedSprint){
      return false;
    }

    // console.log('comparing: ', this.state.cachedSprint.goals);
    // console.log('to: ', this.state.updatedSprint.goals);
    return sprintGoalsAreDirty(this.state.cachedSprint.goals, this.state.updatedSprint.goals);
  }

  renderPageActions(){

    if(this.sprintNeedsSetup()){
      return null;
    }

    const { savingSprint } = this.props;

    return (
      <div className="page-actions">
        <button onClick={this.saveSprint.bind(this)} className="button primary" disabled={!this.sprintIsDirty() || savingSprint}>{savingSprint ? 'Saving...' : 'Save'}</button>
      </div>
    )
  }

  sprintNeedsSetup(){
    return this.props.organization && this.props.sprintData && !this.props.sprintData.goals;
  }

  renderSprintNotSetupMessage(){
    if(!this.sprintNeedsSetup()){
      return null;
    }

    if(this.state.isOwnSprint){
      return(
        <div className="empty-state">
          {getIcon('info')}
          <p>Awaiting your sprint goals to be configured by your manager...</p>
        </div>
      )
    }
    else{
      return(
        <div className="empty-state">
          {getIcon('info')}
          <p>You need to configure sprint goals for this employee!<br/><Link to="./sprint/setup">Setup sprint goals</Link></p>
        </div>
      )
    }
  }

  renderInstructions(){

    const { isViewingUser, viewingUser } = this.props;

    return(
      <div className="instructions">
        <p>For each behavior and skill {isViewingUser ? `${(viewingUser || {}).firstName} is` : 'you are'} focusing on this quarter, define what it would mean to be successful and create an action plan to achieve that goal.</p>
          <p>Here is an example of a good goal and action plan for the <i>Ambition</i> behavior:</p>
          <div className="example">
            <div className="behavior">Ambition</div>
            <div className="definition">Leads with consistency and objectivity through defined, measurable performance criteria.</div>
            <div className="goal"><b>Goal:</b> Achieve all weekly activity goals</div>
            <div className="action-plan"><b>Action plan:</b> Will prioritize weekly activities to be completed before moving onto other tasks. Will work additional hours to ensure goals and objectives are met.</div>
          </div>
      </div>
    )
  }

  render(){

    const { organization, sprintData } = this.props;

    const loading = !organization || !sprintData;

    return (
      <Page pageClass="action-plan" loading={loading}>
        {this.renderPageTitle()}
        {this.renderPageActions()}
        <div className="page-content">
          <div className="page-section">
            {!this.sprintNeedsSetup() && this.renderInstructions()}
            {this.renderGoals()}
            {this.renderSprintNotSetupMessage()}
          </div>
        </div>
      </Page>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    viewingUser: state.viewingUser.data,
    editingUser: state.editingUser,
    organization: state.organization.data,
    savingSprint: state.sprint.saving,
    sprintData: state.sprint.data,
  }
}

export default connect(mapStateToProps, { fetchCurrentSprintForEmployee, saveCurrentSprintForEmployee })(PlanPage);



// WEBPACK FOOTER //
// ./src/components/plan/index.js